import { GetPaymentSubmissionsResponse } from '../../models/paymentSubmissions';
import client from '../httpclient';

const getPaymentSubmissions = (
  patientId: string,
): Promise<GetPaymentSubmissionsResponse> => client
  .get(`/re/v1/patient/${patientId}/reimbursement-request/`);

export default getPaymentSubmissions;
